<script>
    import { createEventDispatcher } from 'svelte';
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import * as m from "@app/paraglide/messages.js";
    
    const dispatch = createEventDispatcher();
    
    function clearSpeakers() {
        // Reset speakers array for all selected events
        eventGroupState[projectState.selected].selected.forEach(eventIndex => {
            eventGroupState[projectState.selected].events[eventIndex].speakers = [];
        });
        
        insertHistoryAction({
            name: "clear speaker(s)", //action name
            eventGroup: projectState.selected,
            snapshots: [
            {
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState),
            },
            ],
        });
        
        dispatch('done');
    }
</script>

<button 
    class="dropdown-item" 
    type="button"
    onclick={clearSpeakers}>
    {m.context_menu_clear_speakers()}
</button>
